import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const BUTTON_CLASS_NAME = tv({
  base: "flex justify-center items-center gap-1",
  variants: {
    size: {
      sm: "h-[32px] rounded-[20px] py-1",
      md: "h-[40px] rounded py-2",
      lg: "h-[50px] rounded py-2",
    },
    styleType: {
      fill: clsx(
        "text-ui-white bg-grayScale-500 font-bold [&_svg]:fill-grayScale-0",
        // hover
        "hover:enabled:bg-grayScale-300",
        // active
        "active:enabled:bg-grayScale-600 [&_svg]:active:enabled:fill-grayScale-0",
        // disabled
        "disabled:bg-grayScale-200 disabled:text-base-disabled disabled:cursor-not-allowed [&_svg]:disabled:fill-base-disabled",
      ),
      outline: clsx(
        "text-ui-500 font-bold bg-ui-white border border-solid border-grayScale-500 [&_svg]:fill-grayScale-400",
        // hover
        "hover:enabled:text-grayScale-400 hover:enabled:border-grayScale-300 [&_svg]:hover:enabled:fill-grayScale-300",
        // active
        "active:enabled:text-ui-600 active:enabled:border-[1.5px] active:enabled:border-grayScale-600 [&_svg]:active:enabled:fill-grayScale-600",
        // disabled
        "disabled:text-base-disabled disabled:bg-ui-100 disabled:border-grayScale-200 disabled:cursor-not-allowed [&_svg]:disabled:fill-ui-200",
      ),
      textLine: clsx(
        "text-ui-500 [&_svg]:fill-grayScale-400",
        // hover
        "hover:enabled:opacity-80 [&_svg]:hover:enabled:opacity-80",
        // activate
        "active:enabled:font-bold active:enabled:text-ui-500 [&_svg]:active:enabled:fill-grayScale-500",
        // disabled
        "disabled:text-base-disabled disabled:cursor-not-allowed [&_svg]:disabled:fill-ui-200",
      ),
    },
    block: { true: "w-full", false: "w-auto" },
    // 初期値は空 compoundVariantsでスタイルあてる
    iconType: { default: "", left: "", right: "", only: "" },
    hasWhiteBorder: {
      true: "border border-solid border-grayScale-100",
    },
    transparent: {
      true: clsx(
        "border-ui-white text-ui-white [&_svg]:fill-ui-white bg-[transparent]",
        "hover:enabled:text-grayScale-200 hover:enabled:border-grayScale-200 [&_svg]:hover:enabled:fill-grayScale-200",
        "active:enabled:text-grayScale-300 active:enabled:border-ui-200 [&_svg]:active:enabled:fill-grayScale-300",
      ),
    },
    // 初期値は空 compoundVariantsでスタイルあてる
    danger: { true: "" },
    warn: { true: "" },
  },
  compoundVariants: [
    /**
     * sizeとアイコンの関係
     */
    {
      size: "sm",
      iconType: ["only", "default"],
      class: "px-4",
    },
    {
      size: "sm",
      iconType: "left",
      class: "pl-2 pr-4",
    },
    {
      size: "sm",
      iconType: "right",
      class: "pr-2 pl-4",
    },

    {
      size: "md",
      iconType: ["only", "default"],
      class: "px-6",
    },
    {
      size: "md",
      iconType: "left",
      class: "pl-4 pr-6",
    },
    {
      size: "md",
      iconType: "right",
      class: "pr-4 pl-6",
    },
    {
      size: "lg",
      iconType: "default",
      class: "px-8",
    },
    {
      size: "lg",
      iconType: "left",
      class: "pl-6 pr-8",
    },
    {
      size: "lg",
      iconType: "right",
      class: "pl-8 pr-6",
    },
    // LGかつアイコンのみの時余白を変えている
    {
      size: "lg",
      iconType: "only",
      class: "px-[13px]",
    },
    // textLineかつiconOnlyのときのみhoverの色と表示領域調整
    {
      styleType: "textLine",
      iconType: "only",
      class:
        "p-1 w-8 h-8 rounded-[30px] hover:enabled:opacity-100 hover:enabled:bg-grayScale-300 [&_svg]:hover:enabled:opacity-100 [&_svg]:hover:enabled:fill-grayScale-0",
    },

    {
      styleType: "fill",
      danger: true,
      class: clsx(
        "bg-functional-danger",
        "hover:enabled:bg-functional-danger hover:enabled:opacity-70",
        "active:enabled:bg-functional-danger active:enabled:opacity-100",
      ),
    },
    {
      styleType: "outline",
      danger: true,
      class: clsx(
        "border border-base-error bg-base-white text-base-error",
        // hover
        "hover:enabled:border-base-error hover:enabled:text-base-error",
        // active
        "active:enabled:border-base-error active:enabled:text-base-error",
        // icon
        "[&_svg]:hover:enabled:fill-base-error [&_svg]:active:enabled:fill-base-error [&_svg]:fill-base-error",
      ),
    },
    // NOTE: outline styleTypeでのデザインしかないので、他のstyleTypeではwarnにしない 20240612
    {
      styleType: "outline",
      warn: true,
      class: "bg-functional-warn-light",
    },
  ],
  defaultVariants: {
    type: "fill",
    size: "md",
    block: false,
    iconType: "default",
    isBgDark: false,
  },
});

export const BUTTON_TEXT_CLASS_NAME = tv({
  base: "pt-[1.5px] break-keep",
  variants: {
    size: {
      sm: "text-ui12",
      md: "text-ui14",
      lg: "text-ui16",
    },
  },
});

export const LOADING_WRAPPER_CLASS_NAME = tv({
  base: "absolute inset-0 opacity-50",
  variants: {
    size: {
      sm: "h-[32px] rounded-[20px]",
      md: "h-[40px] rounded",
      lg: "h-[50px] rounded",
    },
    styleType: {
      fill: "bg-background-gray500",
      outline: "bg-background-gray500",
      textLine: "",
    },
  },
  defaultVariants: {
    size: "md",
  },
});
